import React from "react";
import axios from "axios";
import { notifications } from '@mantine/notifications';
import { Group, Text, Loader, Select } from '@mantine/core';

import { useLoginContext } from "../../context/loginContext";
import { BE_API_TWO, utils } from "../../utils/globalVariables";

import ModalResponse from "../../components/general/ModalResponse";
import InputWrapperCustom from "../../components/general/InputWrapperCustom";

const BarangCategory = ({ stateData, fnOnChange }) => {

    const mountedRef = React.useRef(true);
    const { loginContext, handleSetLoginContext } = useLoginContext();

    const notificationId = React.useRef({
        errorSubmitData: 'barangCategory-1',
    })

    const disabledForThisSteps = [
        utils.projectProcess.pengerjaan.value,
        utils.projectProcess.qc.value,
        utils.projectProcess.selesai.value,
        utils.projectProcess.sudah_diambil.value
    ];

    const disabledSteps = Object.keys(utils.projectProcess)
        .filter(key => disabledForThisSteps.includes(utils.projectProcess[key].value))
        .map(key => utils.projectProcess[key].value);

    const [data, setData] = React.useState({
        submitLoading: false,

        modalResponse: {
            show: false,
            type: utils.modalResponse.warning,
            hideOnClickOutSide: false,
            content: ''
        }
    });

    React.useEffect(() => {
        return () => {
            mountedRef.current = false;
        }
    }, [])

    const submitData = (value) => {
        setData(d => ({
            ...d,
            submitLoading: true,
        }))

        const formDT = new FormData();
        const formDTHeader = { 'Content-Type': 'application/json' }

        formDT.append('json_token', loginContext.syswebapp);
        formDT.append('project_id', stateData.projectId);
        formDT.append('project_process', stateData.projectProcess);
        formDT.append('project_is_cancel', stateData.projectIsCancel);
        formDT.append('project_barang_category', value);

        formDT.append('customer_id', stateData.customerId);
        formDT.append('project_process_sudah_diambil_slug', utils.projectProcess.sudah_diambil.value);

        axios({
            method: 'post',
            url: BE_API_TWO + '/edit_project_barang_category',
            data: formDT,
            headers: formDTHeader,
        }).then((response) => {
            if (!mountedRef.current) return null;

            setData(d => ({ ...d, submitLoading: false }));

            if (response.data.flag_status === 'isset') {
                fnOnChange(value, response.data.data_barang_name_suggestion);
            }

            if (response.data.flag_status === 'error') {
                notifications.show({
                    id: notificationId.current.errorSubmitData,
                    title: utils.notification.warning.caption,
                    message: response.data.pesan,
                    color: utils.notification.warning.color,
                    icon: utils.notification.warning.icon,
                    withBorder: true,
                    autoClose: true,
                })
            }

            if (response.data.flag_status === 'no-data') {
                setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        type: utils.modalResponse.warning,
                        hideOnClickOutSide: true,
                        content: 'Data tidak ditemukan.',
                        show: true
                    }
                }))
            }

            if (response.data.flag_status === 'invalid-json-token') {
                handleSetLoginContext(null);
            }

            if (response.data.flag_status === 'user-inactive') {
                handleSetLoginContext(null);
            }
        }).catch(error => {
            if (!mountedRef.current) return null;

            setData(d => ({
                ...d,
                submitLoading: false
            }))

            notifications.show({
                id: notificationId.current.errorSubmitData,
                title: utils.notification.warning.caption,
                message: error.message,
                color: utils.notification.warning.color,
                icon: utils.notification.warning.icon,
                withBorder: true,
                autoClose: true,
            })
        })
    }

    return (
        <React.Fragment>
            <InputWrapperCustom
                stateLabel={
                    <Group>
                        <Text>{stateData.data.label}</Text>
                        {data.submitLoading && <Loader size="xs" />}
                    </Group>
                }
                stateWithAsterisk={stateData.data.withAsterisk}
                stateError={stateData.data.error}
                stateDescription='Kategori Barang tidak bisa diubah jika sudah mulai masuk ke step Pengerjaan.'
            >
                <Select
                    disabled={disabledSteps.includes(stateData.projectProcess)}
                    value={stateData.data.value.id}
                    onChange={(val) => submitData(val)}
                    data={[
                        { value: '', label: 'Pilih Kategori Barang' },
                        ...stateData.dataBarangCategory.map(key => ({ value: key.barang_category_id, label: key.barang_category_name }))
                    ]}

                    styles={(tema) => ({
                        input: {
                            backgroundColor: tema.colorScheme === 'light' ? '#fff' : tema.colors.dark[7],
                            "&[data-disabled=true]": {
                                color: tema.colorScheme === 'light' ? tema.colors.dark[9] : tema.colors.gray[0]
                            }
                        },
                        wrapper: {
                            marginTop: '.75rem'
                        }
                    })}
                />
            </InputWrapperCustom>

            <ModalResponse
                stateShow={data.modalResponse.show}
                fnHide={() => setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        show: false
                    }
                }))}

                stateHideOnClickOutSide={data.modalResponse.hideOnClickOutSide}
                stateType={data.modalResponse.type}
                stateContent={data.modalResponse.content}
            />
        </React.Fragment>
    )
}

export default BarangCategory;